// Alerts
export const ALERTS_FETCHED = 'ALERTS_FETCHED';
export function alertsFetched(loadedAlertsJson) {
  return {
    type: ALERTS_FETCHED,
    loadedAlertsJson: loadedAlertsJson,
  };
}
export const ALERTS_REQUEST_STARTED = 'ALERTS_REQUEST_STARTED';
export function alertsRequestStarted(muns) {
  return {
    type: ALERTS_REQUEST_STARTED,
    isFetching: true,
    muns: muns,
  };
}

export const ALERTS_REQUEST_ERROR = 'ALERTS_REQUEST_ERROR';
export function alertsRequestError() {
  return {
    type: ALERTS_REQUEST_ERROR,
  };
}

// Alerts Count
export const ALERTS_COUNT_FETCHED = 'ALERTS_COUNT_FETCHED';
export function alertsCountFetched(alertsCount) {
  return {
    type: ALERTS_COUNT_FETCHED,
    alertsCount: alertsCount,
  };
}
export const ALERTS_COUNT_REQUEST_STARTED = 'ALERTS_COUNT_REQUEST_STARTED';
export function alertsCountRequestStarted() {
  return {
    type: ALERTS_COUNT_REQUEST_STARTED,
    isFetching: true,
  };
}

export const ALERTS_COUNT_REQUEST_ERROR = 'ALERTS_COUNT_REQUEST_ERROR';
export function alertsCountRequestError() {
  return {
    type: ALERTS_COUNT_REQUEST_ERROR,
  };
}

// AlertsDetails
export const ALERTS_DETAILS_UPDATED = 'ALERTS_DETAILS_UPDATED';
export function alertsDetailsUpdated(alertsDetails) {
  return {
    type: ALERTS_DETAILS_UPDATED,
    alertsDetails: alertsDetails,
  };
}

export const ALERTS_DETAILS_RESET = 'ALERTS_DETAILS_RESET';
export function alertsDetailsReset() {
  return {
    type: ALERTS_DETAILS_RESET,
  };
}
